import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard  {
  constructor(public router: Router, private authSvc: AuthService) {
  }

  async canActivate(): Promise<boolean> {
    if(this.authSvc.isAuthenticated()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  canActivateChild(): boolean {
    return this.authSvc.isAuthenticated();
  }
}
